import { ClinicalTaskStatus } from '@heidi/schema/ml-scribe';

type StatusTask = {
  id?: string | null;
  status?: ClinicalTaskStatus | null;
  completed_at?: string | null;
};

export const withClinicalTaskStatusTransition = <T extends StatusTask>(
  task: T,
  status: ClinicalTaskStatus,
  previousStatus = task.status
): T => {
  if (previousStatus === status) return task;

  const taskWithStatus = { ...task, status };
  if (status === ClinicalTaskStatus.done) {
    return { ...taskWithStatus, completed_at: new Date().toISOString() };
  }
  if (status === ClinicalTaskStatus.todo || status === ClinicalTaskStatus.in_progress) {
    return { ...taskWithStatus, completed_at: null };
  }
  return taskWithStatus;
};

export const withClinicalTaskStatus = <T extends StatusTask>(
  task: T,
  taskId: string,
  status: ClinicalTaskStatus
): T => {
  if (task.id !== taskId) return task;
  return withClinicalTaskStatusTransition(task, status);
};
